import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    Image,
    Button,
} from 'shared';
import {
    Box, Grid, Heading, Text,
} from '@chakra-ui/react';
import { LuArrowRight } from 'react-icons/lu';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import {
    usePlacesBlockState,
} from '../store';

type CardProps = {
    uid: string,
    name: string,
    image: {
        url?: string
    },
    description?: any
}

const Card: React.FC<CardProps> = ({
    uid,
    name,
    image,
    description,
}) => {
    const [open, setOpen] = useState(false);

    const onMouseEnter = () => setOpen(true);

    const onMouseLeave = () => setOpen(false);

    return (
        <Grid
            gap="2rem"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            cursor="pointer"
        >
            <Link to={`/places/${uid}`} reloadDocument>
                <Grid
                    aspectRatio="3 / 2"
                    position="relative"
                    animation="fade-in 500ms ease-out"
                >
                    <Image
                        pos="absolute"
                        width="100%"
                        height="100%"
                        objectFit="cover"
                        src={image?.url || ''}
                    />
                    <Grid
                        height="100%"
                        gap="1rem"
                        zIndex={2}
                        padding="2rem"
                        margin="auto auto 0 0"
                        templateRows="1fr auto"
                        data-state={open ? 'open' : 'closed'}
                        transition="0.25s"
                        _open={{
                            margin: 'auto 0',
                            backdropFilter: 'blur(10px)',
                        }}
                        _closed={{
                            backdropFilter: 'blur(0px)',
                        }}
                    >
                        <Grid />
                        <Grid
                            data-state={open ? 'open' : 'closed'}
                            gap="0.5rem"
                            _open={{
                                animation: 'fade-in 500ms ease-out',
                            }}
                        >
                            <Heading size="sm" background="black" color="white" padding="0.25rem" width="fit-content">
                                {name}
                            </Heading>
                            <Grid
                                data-state={open ? 'open' : 'closed'}
                                color="white"
                                overflow="hidden"
                                gap="1rem"
                                _open={{
                                    padding: '0.25rem',
                                    background: 'black',
                                    height: 'fit-content',
                                    animation: 'fade-in 0.25s ease-in',
                                }}
                                _closed={{
                                    padding: '0.25rem',
                                    height: 0,
                                    animation: 'fade-out 0.25s ease-out',
                                }}
                            >
                                {description && <BlocksRenderer content={description} />}
                                <Grid templateColumns="auto 1fr" gap="0.5rem">
                                    <Text fontWeight="bold" textDecoration="underline">Подробнее</Text>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Link>
        </Grid>
    );
};

export const PlacesBlock = () => {
    const { places } = usePlacesBlockState();

    const navigate = useNavigate();

    return (
        <Grid
            maxWidth={{
                base: '425px',
                lg: '1280px',
            }}
            width="100%"
            margin="0 auto"
            background="white"
            padding="2rem"
        >
            <Grid gap="1rem">
                <Grid
                    templateColumns={{ base: '1fr', lg: 'auto 1fr' }}
                    gap="2rem"
                >
                    <Heading size="lg">
                        ПАРТНЁРСКИЕ ПЛОЩАДКИ
                    </Heading>
                    <Box margin="auto 0" background="black" height="4px" display={{ base: 'none', lg: 'block' }} />
                </Grid>
                <Grid
                    templateColumns={{
                        base: '1fr',
                        lg: '1fr 1fr',
                    }}
                    gap="1rem"
                >
                    {places.map(({
                        slug, name, images, description,
                    }) => (
                        <Card
                            uid={slug}
                            name={name}
                            image={{ url: images?.at(0)?.url }}
                            description={description}
                        />
                    ))}
                </Grid>
                <Button fontWeight="bold" colorScheme="accent" onClick={() => navigate('/places')}>
                    <Text>
                        Посмотреть все площадки
                    </Text>
                    <LuArrowRight />
                </Button>
            </Grid>
        </Grid>
    );
};
